import { useMemo } from 'react'
import { isDevelopmentDomain } from '../utils/helpers'

export default function useIsDevelopmentDomain() {
    const developmentDomain = useMemo(() => isDevelopmentDomain(), [])
    return developmentDomain
}
